// extracted by mini-css-extract-plugin
export default {"alertTitle":"G7fb176","ineligibleIngredientsWrapper":"G56f938","ineligibleIngredientsInfoTip":"G61221d"};